import { ChartFamily } from './types';
export function resolveMeasureNameHandling(family, configHasMeasureNames) {
    const forceMeasureNames = family === ChartFamily.Cartesian ||
        family === ChartFamily.LineStackedColumn ||
        (family === ChartFamily.Polar && configHasMeasureNames);
    const includeMnMvInRootQuery = forceMeasureNames || configHasMeasureNames;
    return { forceMeasureNames, includeMnMvInRootQuery };
}
//# sourceMappingURL=family.js.map